export default __webpack_public_path__ + "static/media/appstore.ba3a45f4.png";